import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import RegisterForm from '../components/register/RegisterForm';
import styles from './RegisterPage.module.css';

// Public registration page. Reuses the marketing nav/footer and owns its own scroll
// container (global `body { overflow: hidden }` for the app shell). Deliberately short:
// email + password only, like every other prospecting tool's sign-up. Name, company and
// role are collected once on /profile after sign-in; plan selection happens on the
// Account page. The discounted founding-member flow lives at the private /founding URL.
export default function RegisterPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <section className={styles.section}>
          <div className={styles.inner}>
            <div className={styles.head}>
              <div className={styles.brand}>
                <img className={styles.brandLogo} src={`${process.env.PUBLIC_URL}/logo.png`} alt="RepBuddy" />
                <span className={styles.brandName}>RepBuddy</span>
              </div>
              <span className={styles.eyebrow}>Sign up</span>
              <h1 className={styles.headline}>Create your free RepBuddy account.</h1>
              <p className={styles.sub}>
                Four AI agents that find, verify, and engage your next customers.
                Free 7-day trial, no credit card required.
              </p>
              <div className={styles.perks}>
                <span className={styles.perk}>⚡ 7-day free trial</span>
                <span className={styles.perk}>✓ No credit card required</span>
                <span className={styles.perk}>★ Cancel anytime</span>
              </div>
            </div>
            <RegisterForm variant="public" />
            <p className={styles.switchAuth}>
              Already have an account?{' '}
              <Link className={styles.switchLink} to="/login">Log in</Link>
            </p>
          </div>
        </section>
      </main>
      <LandingFooter />
    </div>
  );
}
